jQuery_T4NT(document).ready(function($) {



    function shuffleSlides1() {
    const slides = document.querySelectorAll('.brswiper2 .swiper-slide');
    const slidesArray = Array.from(slides);
    
   
    for (let i = slidesArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [slidesArray[i], slidesArray[j]] = [slidesArray[j], slidesArray[i]];
    }

    
    const swiperWrapper = document.querySelector('.brswiper2 .swiper-wrapper');
    swiperWrapper.innerHTML = ''; 

   
    slidesArray.forEach(slide => swiperWrapper.appendChild(slide));
  }

   
 

  
  function shuffleSlides() {
    const slides = document.querySelectorAll('.brswiper .swiper-slide');
    const slidesArray = Array.from(slides);
    
   
    for (let i = slidesArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [slidesArray[i], slidesArray[j]] = [slidesArray[j], slidesArray[i]];
    }

    
    const swiperWrapper = document.querySelector('.brswiper .swiper-wrapper');
    swiperWrapper.innerHTML = ''; 

   
    slidesArray.forEach(slide => swiperWrapper.appendChild(slide));
  }
if ($('.brzdocs').length > 0) {
  // shuffleSlides1(); 
// shuffleSlides();
}
 

 // const swiperbrazil = new Swiper(".brswiper", {
 //    loop: false,
 //     slidesPerView: 4,
 //     spaceBetween:60,
 //    autoplay:false,
 //  scrollbar: {
 //      el: '.swiper-scrollbar',
 //      draggable: true,
 //    },
 //    navigation: {
 //      nextEl: ".snx1",
 //      prevEl: ".spv1",
 //    },
 //     breakpoints: {
 //    // when window width is >= 320px
 //    320: {
 //      slidesPerView: 1,
 //      spaceBetween: 20
 //    },
 //    // when window width is >= 480px
 //    480: {
 //      slidesPerView: 1,
 //      spaceBetween: 30
 //    },
 //    // when window width is >= 640px
 //    640: {
 //      slidesPerView: 2,
 //      spaceBetween: 40
 //    },
 //        1300: {
 //      slidesPerView: 3,
 //      spaceBetween: 40
 //    },
 //          1500: {
 //      slidesPerView: 4,
 //      spaceBetween: 40
 //    }
 //  }
   
 //  });
  




 // const swiperbrazil2 = new Swiper(".brswiper2", {
 //    loop: false,
 //     slidesPerView: 4,
 //     spaceBetween:60,
 //    autoplay:false,
 
 //    navigation: {
 //      nextEl: ".snx",
 //      prevEl: ".spv",
 //    },
 //       breakpoints: {
 //    // when window width is >= 320px
 //    320: {
 //      slidesPerView: 1,
 //      spaceBetween: 20
 //    },
 //    // when window width is >= 480px
 //    480: {
 //      slidesPerView: 1,
 //      spaceBetween: 30
 //    },
 //    // when window width is >= 640px
 //    640: {
 //      slidesPerView: 4,
 //      spaceBetween: 40
 //    }
 //  }
   
 //  });

   const collswiper = new Swiper(".collswiper", {
    loop: false,
     slidesPerView: 4,
     spaceBetween:20,
    autoplay:false,
 
   // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
       breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
      spaceBetween: 20
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 1,
      spaceBetween: 30
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 2,
      spaceBetween: 40
    },
          1200: {
      slidesPerView: 4,
      spaceBetween: 40
    }
  }
   
  });
  
if ($(window).width() <= 1024) {
  $(".explore .expaa").click(function(){
    //event.preventDefault();
   // $(".t4s-push-menu-btn").click();
        
    })
  $('.explore').click(function () {
      console.log("test");
      // $(".msmenu1").hide();
      $('.explore').not(this).find(".msmenu1").hide();
       $(this).find('.msmenu1').fadeToggle(500);
      
     });

$(window).click(function() {
 $(".msmenu1").hide();
});

$('.explore').click(function(event){
  event.stopPropagation();
});


  
}else{
$('.explore').mouseenter(function () {
       $(this).find('.msmenu1').fadeIn(500);
      
     });

 $('.explore').mouseleave(function () {
        $(this).find('.msmenu1').hide();
     }
 ).mouseleave();


}





  




  

    
  $(".ms2 a").hover(function(){var elid=$(this).attr("data-id");console.log(elid);$(".prod-im .pim").hide();$("."+elid).show();})

$(".ms3 a").hover(function(){
  
                    var elid=$(this).attr("data-id");
                   console.log(elid);$(".prod-im .pim").hide();
                    $("."+elid).show();
  
})

    

  if (window.location.href.indexOf("product-documentation") > -1) {
  if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

    }

  
  $(".lit").click(function(e){
    e.preventDefault();
$(".lit").removeClass("active");
$(this).addClass("active");
    var lid=$(this).find("a").attr("data-target");
   console.log(lid);
    $(".hmtb").hide();
    $(""+lid).show();
})


if($(window).width() > 1024)
{
  $(".t4s-site-nav__icon.t4s-site-nav__cart a").click(function(){
    event.preventDefault();
    $(".t4s-close-overlay").css("display","none");
    $('#t4s-mini_cart').css("display","none");
    window.location.href="/cart";
})
  
}


  

$(document).on('click touchstart', '.getmec label', function (e){


  console.log("labelclick..")
  $(this).closest(".getmec").find("label").removeClass("active");
  $(this).addClass("active");
var gid=$(this).attr("id");
    console.log(gid);
    $(this).closest(".getcri").find(".getmecon .getcc").hide();
    $(this).closest(".getcri").find("."+gid).fadeIn(500);
})

$(".t4s-tab-item").click(function(){
    var api = new Yotpo.API(yotpo);
api.refreshWidgets();
})
     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });


var Lslide      = document.querySelectorAll('.Lslide'),
    Rslide      = document.querySelectorAll('.Rslide'),
    control     = document.querySelectorAll('.oncontrol'),
    slideHeight = document.querySelector('.wrapper').clientHeight,
    color = ['#fdc97c', '#e5d3d0', '#71b3d6'],
    index = 0;


function init() {
    slideHeight = document.querySelector('.wrapper').clientHeight;
    for (i = 0; i < Lslide.length; i++) {
        Lslide[i].style.backgroundColor = color[i];
        Lslide[i].style.top = -slideHeight * i + "px";
        Rslide[i].style.top = slideHeight * i + "px";
    }  
}
init()
window.addEventListener('resize', function(){
    init()
});

function moveToTop() {

    index++;
    for (el = 0; el < Lslide.length; el++) {
        Lslide[el].style.top = parseInt(Lslide[el].style.top) + slideHeight + "px";
        Rslide[el].style.top = parseInt(Rslide[el].style.top) - slideHeight + "px";
    }

    if (index > Lslide.length-1) {
        index = 0;
        for (el = 0; el < Lslide.length; el++) {
            Lslide[el].style.top = -slideHeight * el + "px";
            Rslide[el].style.top = slideHeight * el + "px";
        }
    }
}

function moveToBottom() {
    index--;
    for (el = 0; el < Lslide.length; el++) {
        Lslide[el].style.top = parseInt(Lslide[el].style.top) - slideHeight + "px";
        Rslide[el].style.top = parseInt(Rslide[el].style.top) + slideHeight + "px";
        
    }
    if (index < 0) {
        index = Rslide.length-1;
        for (el = 0; el < Lslide.length; el++) {
            Lslide[el].style.top = parseInt(Lslide[el].style.top) + slideHeight * Lslide.length + "px";
            Rslide[el].style.top = parseInt(Rslide[el].style.top) - slideHeight * Rslide.length + "px";
        }
    }
}

function transition() {
    for (t = 0; t < Lslide.length; t++) {
        Lslide[t].style.transition = "all 0.8s";
        Rslide[t].style.transition = "all 0.8s";
    }
}
  

for (t = 0; t < control.length; t++) {
    control[t].addEventListener("click", function() {

        if (this.classList.contains('control-top')) {
            moveToTop()
        } 
        if (this.classList.contains('control-bottom')) {
            moveToBottom()
        }

        transition()
   
    });
}

var wheeling;
function mousemouve(e) {

    clearTimeout(wheeling);
    e.preventDefault();
    var e = window.event || e; 
    var delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
    
    wheeling = setTimeout(function() {
        wheeling = undefined;
        if (delta === 1) {
            moveToTop()
        }
        if (delta === -1) {
            moveToBottom()
        }
    }, 100);

    transition()
}
 timer = setInterval(function() { 
 moveToBottom();
  transition()
        }, 7000);
//document.addEventListener("mousewheel", mousemouve);
//document.addEventListener("DOMMouseScroll", mousemouve);





 

$(".t4s-footer-heading").click()



  
});


var swiper = new Swiper('.mySwiperspbe', {
  // Default parameters
  slidesPerView: 1,
  spaceBetween: 10,

    navigation: {
    nextEl: '.swnext',
    prevEl: '.swprev',
  },
  // Responsive breakpoints
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
      spaceBetween: 10
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 1,
      spaceBetween: 10
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 1,
      spaceBetween: 40
    },
    1200: {
      slidesPerView: 1,
      spaceBetween: 40
    }
  }
})


// Function that actually builds the swiper 
const buildSwiperSlider = sliderElm => {
    const sliderIdentifier = sliderElm.dataset.id;
  console.log(sliderIdentifier);
    return new Swiper("#"+sliderIdentifier, {
         mousewheel: {
        forceToAxis: true,
       
    },
      slidesPerView: 1.5,
      spaceBetween: 20,
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
          cssMode: true,
        },
        // when window width is >= 480px
        680: {
          slidesPerView: 4,
          spaceBetween: 10
        },
        // when window width is >= 640px
        900: {
          slidesPerView: 4,
          spaceBetween: 10
        },
          1500: {
          slidesPerView: 4,
          spaceBetween: 10
        }
      }
       
    });
}
if (window.innerWidth > 999) {
// Get all of the swipers on the page
const allSliders = document.querySelectorAll('.mySwiperx');

// Loop over all of the fetched sliders and apply Swiper on each one.
allSliders.forEach(slider => buildSwiperSlider(slider));
}





if (document.querySelector('.logoSwiper') && typeof Swiper !== 'undefined') {
var swiper = new Swiper('.logoSwiper', {
  // Default parameters
  slidesPerView: 6,
  spaceBetween: 10,
  autoplay: {
        delay: 2500,
        disableOnInteraction: false
      },
 
  // Responsive breakpoints
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 3,
      spaceBetween: 30
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 4,
      spaceBetween: 40
    },
    1200: {
      slidesPerView: 6,
      spaceBetween: 40
    }
  }
})
}


// Legacy accordion handler replaced by assets/rb-faq-accordion.js


// Product documentation batch search moved to assets/rb-docs-search.js
// (custom.js often throws earlier on docs pages, so these handlers never bound.)


   $(".itemcl").click(function(){
$(this).toggleClass("selected");
if($(this).hasClass("selected")){
 $(this).find('input').prop('checked', true); 
}else{
  $(this).find('input').prop('checked', false); 
}

})

 jQuery(".fmenu p").click(function(){

    jQuery(".fmenu p").removeClass("active");
    jQuery(this).addClass("active");
    var id=jQuery(this).attr("data-id");
    console.log(id);
    jQuery(".fq").hide();
    jQuery(".faq"+id).fadeIn(500);
})

$('.hl2 .menu-item-type-custom').mouseenter(function () {
      // $(this).find('.msmenu').show();
       
     });

 $('.hl2 .menu-item-type-custom').mouseleave(function () {
       //$(this).find('.msmenu').hide();
   
     }
 ).mouseleave();


const myTimeout = setTimeout(myGreeting, 2000);
function myGreeting(){  
jQuery("#t4s-menu-drawer").prepend("<img src='https://cdn.shopify.com/s/files/1/0029/5682/0569/t/29/assets/canna-river-logo.png?v=1681746857'>");
}



$(".tabs-menu div").click(function(){
    $(".tabs-menu div").removeClass("active");
    $(this).addClass("active");
var x=$(this).attr("id");
   $(".tbs").hide();
    $("."+x).fadeIn();
    
})












$("section#shopify-section-template--15427491332189__c4d5f907-d8c3-4869-aa04-50e26376bbda").click(function(){
   $(this).addClass("remafter");
})


$(".t4s-site-nav__account").click(function(event){
event.preventDefault();
    window.location.href='https://www.riverbotanicals.com/account/login';
})

if($('.imhover img').attr('src') == '') { 
     
    }else{

    
 $('.imhovercon').mouseenter(function () {
       $(".imhover").show();
       $('.imhoverx').hide();
     });

 $('.imhovercon').mouseleave(function () {
      $(".imhover").hide();
       $('.imhoverx').show();
     }
 ).mouseleave();

$('.imhovercon').on('touchstart ', function(e) {
if($(".imhover").is(":visible")){
     $(".imhover").hide();
     $('.imhoverx').show();
}else
{
    $(".imhover").show();
    $('.imhoverx').hide();
}
})                
  

  // $('.imhovercon').on('touchstart ', function(e) {
  //        $(".imhover").show();
  //      $('.imhoverx').hide();
  //   });
  //    $('.imhovercon').on('touchend ', function(e) {
  //       $(".imhover").hide();
  //      $('.imhoverx').show();
  //   }); 


  
    }






   (function() {

      $(document).on("click",".rc-radio", function(){
        console.log("evt handler")
         if($(this).hasClass("subscription-radio")){
       
       $(".sbs_message").show();
      
   }else{
       
       $(".sbs_message").hide();
       
   }
    
  });

setTimeout(function(){

$rcd=$(".rc-button-group__options").find(".rc-radio--active");
console.log($rcd);
if($rcd.hasClass("onetime-radio")){
  console.log('onetime');
    $(".sbs_message").hide();
}
else{
    $(".sbs_message").show();
}
  

},2000);


    

    


     
})();